import { createStyles, makeStyles, Theme } from "@material-ui/core";
import { useTranslation } from "react-i18next";

const styles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            display: "flex",
            background: "#ff91a4",
            padding: 20,
            marginBottom: 30,
            color: "white",
            width: "50%",
            marginRight: "auto",
            marginLeft: "auto",
            borderRadius: 10,
            textAlign: "center",
            justifyContent: "center",
            [theme.breakpoints.down("xs")]: {
                width: "100%"
            },
        }
    })
);

export default function MessageBrouillon(){
    const classes = styles();
    const { t } = useTranslation<'common'>()
    return(
        <div className={classes.root}>
            {t('annonce.message.brouillon')}
        </div>
    )
}